import * as React from 'react'

import { AutomationStep } from 'modules/automations/components/Show/Step'

type AutomationStepProps = React.ComponentProps<typeof AutomationStep>

interface Props {
  disabled: boolean
  title: string
  onClick: AutomationStepProps['onClick']
  trigger?: string
  withLastSpacer?: boolean
}

export function AutomationTrigger({
  disabled = false,
  title,
  onClick,
  withLastSpacer,
  trigger
}: Props) {
  return (
    <AutomationStep
      disabled={disabled}
      title={title}
      stepType="trigger"
      onClick={onClick}
      trigger={trigger}
      withLastSpacer={withLastSpacer}
    />
  )
}
